export default "__VITE_ASSET__D24hLh5l__"